'use client'

import { Suspense } from 'react'
import { useSearchParams } from 'next/navigation'
import { ClientPrescriptionPreview } from '@/features/investor'
import { Skeleton } from '@/components/ui/skeleton'
import type { FlowType } from '@/features/cases'
import { AdminShell } from '@/features/admin/components/admin-shell'

/** Reads `?flow=` itself instead of the page taking it via `searchParams` — see
 * `staff-client-detail-view.tsx` for why (a simplification; does NOT fix the tab-title flicker). */
function AdminClientPrescriptionPreviewContent({ investorId }: { investorId: string }) {
  const flow = useSearchParams().get('flow')
  const resolvedFlow: FlowType = flow === 'trades' ? 'trades' : 'audit'
  return <ClientPrescriptionPreview investorId={investorId} flow={resolvedFlow} />
}

export function AdminClientPrescriptionPreviewView({ investorId }: { investorId: string }) {
  return (
    <AdminShell active="cases">
      <Suspense fallback={<Skeleton className="h-64 w-full" />}>
        <AdminClientPrescriptionPreviewContent investorId={investorId} />
      </Suspense>
    </AdminShell>
  )
}
